import React, { useEffect, useRef, useState } from "react";
import "./Amc.css";
import TextField from "@material-ui/core/TextField";
import {
  Autocomplete,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../Componants/Common/Button";
import Paginate from "../../../Componants/Common/Paginate";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import config from "../../../Componants/Common/config";
import {
  addAmc,
  amcStatusUpdate,
  exportAmc,
  fetchAmcMaster,
  fetchBrandList,
  fetchCategoryList,
  fetchModelList,
  fetchSubCategoryListActive,
  updateAmc,
  fetchModelListActive,
  getAmcDropdown,
} from "../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import { downloadFile } from "../../../utils/downloadHelper";


const calltype = [];

const Amc = () => {
  const pageSize = config.pageSize;
  const [editindex, setEditIndex] = useState(null);
  const editRef = useRef(null);
  const [amcId, setAmcId] = useState(0);

  //Dropdowms
  const [activeBrandList, setActiveBrandList] = useState([]);
  const [catDrop, setCatDrop] = useState([]);
  const [subCatDrop, setSubCatDrop] = useState([]);
  const [modelDrop, setModelDrop] = useState([]);

  const [activeBrandListSearch, setActiveBrandListSearch] = useState([]);
  const [catDropSearch, setCatDropSearch] = useState([]);
  const [subCatDropSearch, setSubCatDropSearch] = useState([]);
  const [modelDropSearch, setModelDropSearch] = useState([]);
  const [amclistSearch, setAmclistSearch] = useState([]);
  const [amclistForm, setAmclistForm] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataSize, setDataSize] = useState(pageSize);

  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [flag, setFlag] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    modelId: "",
    noOfServices: "",
    costOfService: "",
    duration: "",
    description: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    modelId: "",
    noOfServices: "",
    costOfService: "",
    duration: "",
    description: "",
  });

  const [searchParams, setSearchParams] = useState({
    amcName: "",
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    modelId: "",
    page: page,
    pageSize: pageSize,
  });

  const [amcs, setAmcs] = useState([]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setSearchParams((prevParams) => ({
      ...prevParams,
      page: newPage.toString(),
      pageSize: page,
    }));
  };

  useEffect(() => {
    fetchAMC();
  }, [flag, page]);
  useEffect(() => {
    getBrandList();
    fetchAmcLookupSearch();
  }, []);

  const fetchAmcLookupSearch = async (overrideParams = null) => {
    try {
      const params = overrideParams || searchParams;
      const res = await getAmcDropdown({
        brandId: params.brandId || "",
        categoryId: params.categoryId || "",
        subcategoryId: params.subcategoryId || "",
        modelId: params.modelId || "",
        page: 1,
        pageSize: 100,
      });
      setAmclistSearch(res.data || []);
    } catch (e) { console.error(e) }
  };

  const fetchAmcLookupForm = async (currentForm) => {
    try {
      const res = await getAmcDropdown({
        brandId: currentForm.brandId || "",
        categoryId: currentForm.categoryId || "",
        subcategoryId: currentForm.subcategoryId || "",
        modelId: currentForm.modelId || "",
        page: 1,
        pageSize: 100,
      });
      setAmclistForm(res.data || []);
    } catch (e) { console.error(e) }
  };

  const handleChange = async (fieldName, value) => {
    setFormErrors(prev => ({ ...prev, [fieldName]: "" }));

    if (["noOfServices", "costOfService", "duration"].includes(fieldName)) {
      if (value === "" || value === null) {
        setFormData(prev => ({ ...prev, [fieldName]: "" }));
        return;
      }
      const numValue = Number(value);
      if (!isNaN(numValue) && numValue >= 0) {
        setFormData(prev => ({ ...prev, [fieldName]: numValue }));
      }
      return;
    }

    if (fieldName === "name") {
      const nameRegex = /^[a-zA-Z0-9\s\-_.]*$/;
      if (value === "" || nameRegex.test(value)) {
        setFormData(prev => ({ ...prev, [fieldName]: value }));
      }
      return;
    }

    if (fieldName === "description") {
      setFormData(prev => ({ ...prev, [fieldName]: value }));
      return;
    }

    if (fieldName === "brandId" && !value) {
      setCatDrop([]);
      setSubCatDrop([]);
      setModelDrop([]);
      setAmclistForm([]);
      setFormData((p) => ({ ...p, categoryId: "", subcategoryId: "", modelId: "", [fieldName]: value }));
    } else if (fieldName === "categoryId" && !value) {
      setSubCatDrop([]);
      setModelDrop([]);
      setAmclistForm([]);
      setFormData((p) => ({ ...p, subcategoryId: "", modelId: "", [fieldName]: value }));
    } else if (fieldName === "subcategoryId" && !value) {
      setModelDrop([]);
      setAmclistForm([]);
      setFormData((p) => ({ ...p, modelId: "", [fieldName]: value }));
    } else if (fieldName === "modelId" && !value) {
      setAmclistForm([]);
      setFormData((p) => ({ ...p, [fieldName]: value }));
    } else {
      setFormData((p) => ({ ...p, [fieldName]: value }));
    }

    if (fieldName === "brandId" && value) {
      try {
        setLoading(true);
        const response = await fetchCategoryList(value, "", 1, 100, true);
        setCatDrop(response.data.categories);
      } catch (error) { console.error(error); } finally { setLoading(false); }
    }

    if (fieldName === "categoryId" && value) {
      try {
        setLoading(true);
        const response = await fetchSubCategoryListActive("", 1, 1000, formData.brandId, value, true);
        setSubCatDrop(response.data.subcategory);
      } catch (error) { console.error(error); } finally { setLoading(false); }
    }

    if (fieldName === "subcategoryId" && value) {
      try {
        setLoading(true);
        const response = await fetchModelListActive("", 1, 1000, formData.brandId, formData.categoryId, value);
        setModelDrop(response.data.models);
      } catch (error) { console.error(error); } finally { setLoading(false); }
    }

    if (fieldName === "modelId" && value) {
      fetchAmcLookupForm({ ...formData, modelId: value });
    }
  };

  const handleSearchChange = async (fieldName, value) => {
    let newParams = { ...searchParams, [fieldName]: value };
    if (fieldName === "brandId") {
      newParams = { ...newParams, categoryId: "", subcategoryId: "", modelId: "", amcName: "" };
      setCatDropSearch([]);
      setSubCatDropSearch([]);
      setModelDropSearch([]);
      setAmclistSearch([]);
    } else if (fieldName === "categoryId") {
      newParams = { ...newParams, subcategoryId: "", modelId: "", amcName: "" };
      setSubCatDropSearch([]);
      setModelDropSearch([]);
      setAmclistSearch([]);
    } else if (fieldName === "subcategoryId") {
      newParams = { ...newParams, modelId: "", amcName: "" };
      setModelDropSearch([]);
      setAmclistSearch([]);
    } else if (fieldName === "modelId") {
      newParams = { ...newParams, amcName: "" };
      setAmclistSearch([]);
    }

    if (fieldName === "brandId" && value) {
      try {
        setLoading(true);
        const response = await fetchCategoryList(value, "", 1, 100, true);
        setCatDropSearch(response.data.categories || []);
      } catch (e) { console.error(e) } finally { setLoading(false) }
    } else if (fieldName === "categoryId" && value) {
      try {
        setLoading(true);
        const response = await fetchSubCategoryListActive("", 1, 1000, newParams.brandId, value, true);
        setSubCatDropSearch(response.data.subcategory || []);
      } catch (e) { console.error(e) } finally { setLoading(false) }
    } else if (fieldName === "subcategoryId" && value) {
      try {
        setLoading(true);
        const response = await fetchModelList("", 1, 1000, newParams.brandId, newParams.categoryId, value);
        setModelDropSearch(response.data.models || []);
      } catch (e) { console.error(e) } finally { setLoading(false) }
    } else if (fieldName === "modelId" && value) {
      fetchAmcLookupSearch(newParams);
    }

    setSearchParams(newParams);
  };

  const handleShowAll = () => {
    setFlag(!flag);
    setPage(1);
    setSearchParams({ amcName: "", brandId: "", categoryId: "", subcategoryId: "", modelId: "", page: 1, pageSize: 10 });
    setAmclistSearch([]);
    setCatDropSearch([]);
    setSubCatDropSearch([]);
    setModelDropSearch([]);
  };

  const getBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandList();
      const filteredActiveBrands = response.data.brandList.filter((brand) => brand.active === true);
      setActiveBrandList(filteredActiveBrands);
      setActiveBrandListSearch(filteredActiveBrands);
    } catch (error) { console.error(error); } finally { setLoading(false); }
  };

  const fetchAMC = async () => {
    setLoading(true);
    let body = { ...searchParams, name: searchParams.amcName || "", brandId: searchParams.brandId || "", categoryId: searchParams.categoryId || "", subcategoryId: searchParams.subcategoryId || "", modelId: searchParams.modelId || "" };
    try {
      let res = await fetchAmcMaster(body);
      setAmcs(res.data.amcs);
      setTotalRecords(res.data.totalAmcs);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error");
      setTotalRecords(0);
      setAmcs([]);
    } finally { setLoading(false); }
  };

  const handleStatusChange = async (id) => {
    setLoading(true);
    try {
      let res = await amcStatusUpdate({ amcId: id });
      toast.success(res.message);
      setFlag(!flag);
    } catch (error) { toast.error(error.response?.data?.message || "Error"); }
    setLoading(false);
  };

  const validateForm = () => {
    let isValid = true;
    const errors = { name: "", brandId: "", categoryId: "", subcategoryId: "", modelId: "", noOfServices: "", costOfService: "", duration: "", description: "" };
    if (!formData.name.trim()) { errors.name = "AMC Name is required"; isValid = false; }
    if (!formData.brandId) { errors.brandId = "Brand is required"; isValid = false; }
    if (!formData.categoryId) { errors.categoryId = "Category is required"; isValid = false; }
    if (!formData.subcategoryId) { errors.subcategoryId = "Sub Category is required"; isValid = false; }
    if (!formData.modelId) { errors.modelId = "Model is required"; isValid = false; }
    if (!formData.noOfServices || formData.noOfServices <= 0) { errors.noOfServices = "Number of services must be greater than 0"; isValid = false; }
    if (!formData.costOfService || formData.costOfService <= 0) { errors.costOfService = "AMC cost must be greater than 0"; isValid = false; }
    if (!formData.duration || formData.duration <= 0) { errors.duration = "Duration must be greater than 0"; isValid = false; }
    if (!formData.description.trim()) { errors.description = "Description is required"; isValid = false; }
    setFormErrors(errors);
    return isValid;
  };

  const resetForm = () => {
    setFormData({ name: "", brandId: "", categoryId: "", subcategoryId: "", modelId: "", noOfServices: "", costOfService: "", duration: "", description: "" });
    setFormErrors({ name: "", brandId: "", categoryId: "", subcategoryId: "", modelId: "", noOfServices: "", costOfService: "", duration: "", description: "" });
    setEditIndex(null);
    setAmcId(null);
    setCatDrop([]);
    setSubCatDrop([]);
    setModelDrop([]);
    setAmclistForm([]);
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      if (editindex != null) {
        let res = await updateAmc({ ...formData, amcId: amcId });
        toast.success(res.message);
      } else {
        let res = await addAmc(formData);
        toast.success(res.message);
      }
      setFlag(!flag);
      resetForm();
    } catch (error) { toast.error(error.response?.data?.message || "Operation Failed"); }
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const response = await exportAmc(searchParams);
      if (response?.status === "success" && response?.data?.filePath) {
        downloadFile(response.data.filePath);
        toast.success("File downloaded successfully");
      } else { toast.error(response.message || "Invalid response"); }
    } catch (error) { toast.error(error.response?.data?.message || "Invalid response"); } finally { setLoading(false); }
  };

  const handleSearch = () => {
    setPage(1);
    setSearchParams((p) => ({ ...p, page: 1, pageSize: 10 }));
    setFlag(!flag);
  };

  const handleClear = () => resetForm();

  const handleEdit = async (ind) => {
    const editData = amcs[ind];
    setEditIndex(ind);
    setAmcId(editData._id);
    try {
      setLoading(true);
      const [catRes, subRes, modRes] = await Promise.all([
        fetchCategoryList(editData.brandId, "", 1, 100, true),
        fetchSubCategoryListActive("", 1, 1000, editData.brandId, editData.categoryId, true),
        fetchModelList("", 1, 1000, editData.brandId, editData.categoryId, editData.subcategoryId)
      ]);
      setCatDrop(catRes.data.categories);
      setSubCatDrop(subRes.data.subcategory);
      setModelDrop(modRes.data.models);
    } catch (error) { console.error(error); } finally { setLoading(false); }
    setFormData({ name: editData.name, brandId: editData.brandId, categoryId: editData.categoryId, subcategoryId: editData.subcategoryId, modelId: editData.modelId, noOfServices: editData.noOfServices, costOfService: editData.costOfService, duration: editData.duration, description: editData.description });
  };

  const scrollToEdit = () => {
    if (editRef.current) editRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const buttonStyle = {
    backgroundColor: "#33499F",
    color: "white",
    boxShadow: "4px 2px 4px rgb(110, 142, 237)",
    fontSize: "14px",
    minWidth: "100px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#33499F",
    },
  };

  const iconButtonStyle = {
    outline: "none",
    "&:focus": { outline: "none" },
  };

  return (
    <>
      <HeaderNavigation value={"AMC > AMC Master"} location={"/setting"} />
      {loading && <Loader />}
      <Toaster />
      <div className="firsttextbox-amc" ref={editRef}>
        <div className="line-Amc">
          <div className="textinput-Amc">
            <Autocomplete id="brand-autocomplete" closeOnSelect options={activeBrandList} value={activeBrandList.find(o => o._id === formData.brandId) || null} onChange={(_, val) => handleChange("brandId", val?._id || "")} getOptionLabel={o => o.brandName || ""} renderInput={p => <TextField {...p} label="Brand *" variant="standard" style={{ width: "10rem" }} error={!!formErrors.brandId} helperText={formErrors.brandId} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="category-autocomplete" closeOnSelect options={catDrop} value={catDrop.find(o => o._id === formData.categoryId) || null} onChange={(_, val) => handleChange("categoryId", val?._id || "")} getOptionLabel={o => o.categoryName || ""} renderInput={p => <TextField {...p} label="Category *" variant="standard" style={{ width: "10rem" }} error={!!formErrors.categoryId} helperText={formErrors.categoryId} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="subcategory-autocomplete" closeOnSelect options={subCatDrop} value={subCatDrop.find(o => o._id === formData.subcategoryId) || null} onChange={(_, val) => handleChange("subcategoryId", val?._id || "")} getOptionLabel={o => o.subcategoryName || ""} renderInput={p => <TextField {...p} label="Sub Category *" variant="standard" style={{ width: "10rem" }} error={!!formErrors.subcategoryId} helperText={formErrors.subcategoryId} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="model-autocomplete" closeOnSelect options={modelDrop} value={modelDrop.find(o => o._id === formData.modelId) || null} onChange={(_, val) => handleChange("modelId", val?._id || "")} getOptionLabel={o => o.modelName || ""} renderInput={p => <TextField {...p} label="Model *" variant="standard" style={{ width: "10rem" }} error={!!formErrors.modelId} helperText={formErrors.modelId} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="amc-autocomplete" options={amclistForm} freeSolo getOptionLabel={o => (typeof o === 'string' ? o : o.name || "")} value={formData.name || ""} onInputChange={(_, val) => handleChange("name", val)} onChange={(_, val) => { const finalValue = typeof val === 'string' ? val : val?.name || ""; handleChange("name", finalValue); }} renderInput={p => <TextField {...p} label="AMC Name *" variant="standard" style={{ width: "100%" }} error={!!formErrors.name} helperText={formErrors.name} />} />
          </div>
        </div>
        <div className="line-Amc">
          <div className="textinput-Amc">
            <TextField style={{ width: "100%" }} id="noOfServices" label="No. of Services *" variant="standard" type="number" value={formData.noOfServices} onChange={e => handleChange("noOfServices", e.target.value)} error={!!formErrors.noOfServices} helperText={formErrors.noOfServices} />
          </div>
          <div className="textinput-Amc">
            <TextField style={{ width: "100%" }} id="costOfService" label="AMC Cost (INR) *" variant="standard" type="number" value={formData.costOfService} onChange={e => handleChange("costOfService", e.target.value)} error={!!formErrors.costOfService} helperText={formErrors.costOfService} />
          </div>
          <div className="textinput-Amc">
            <TextField style={{ width: "100%" }} id="duration" label="Duration (in Months) *" variant="standard" type="number" value={formData.duration} onChange={e => handleChange("duration", e.target.value)} error={!!formErrors.duration} helperText={formErrors.duration} />
          </div>
        </div>
        <div className="line-Amc">
          <div className="textinput-Amc">
            <TextField label="Description *" variant="outlined" multiline rows={4} value={formData.description} onChange={e => handleChange("description", e.target.value)} error={!!formErrors.description} helperText={formErrors.description} sx={{ width: "400px", mb: 2, backgroundColor: "#fff !important" }} />
          </div>
        </div>
        <div className="buttons-Amc" style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', marginBottom: "10px" }}>
          <Button onClick={handleSubmit} sx={buttonStyle} variant="contained">{editindex == null ? "Create" : "Update"}</Button>
          <Button onClick={handleClear} sx={buttonStyle} variant="contained">Clear</Button>
        </div>
      </div>
      <div className="Secoundtextbox-amc" style={{ marginBottom: "20px" }}>
        <div className="line-Amc">
          <div className="textinput-Amc">
            <Autocomplete id="brand-search" options={activeBrandListSearch} value={activeBrandListSearch.find(o => o._id === searchParams.brandId) || null} onChange={(_, val) => handleSearchChange("brandId", val?._id || "")} getOptionLabel={o => o.brandName || ""} renderInput={p => <TextField {...p} label="Brand" variant="standard" style={{ width: "10rem" }} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="category-search" options={catDropSearch} value={catDropSearch.find(o => o._id === searchParams.categoryId) || null} onChange={(_, val) => handleSearchChange("categoryId", val?._id || "")} getOptionLabel={o => o.categoryName || ""} renderInput={p => <TextField {...p} label="Category" variant="standard" style={{ width: "10rem" }} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="subcategory-search" options={subCatDropSearch} value={subCatDropSearch.find(o => o._id === searchParams.subcategoryId) || null} onChange={(_, val) => handleSearchChange("subcategoryId", val?._id || "")} getOptionLabel={o => o.subcategoryName || ""} renderInput={p => <TextField {...p} label="Sub Category" variant="standard" style={{ width: "10rem" }} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="model-search" options={modelDropSearch} value={modelDropSearch.find(o => o._id === searchParams.modelId) || null} onChange={(_, val) => handleSearchChange("modelId", val?._id || "")} getOptionLabel={o => o.modelName || ""} renderInput={p => <TextField {...p} label="Model" variant="standard" style={{ width: "10rem" }} />} />
          </div>
          <div className="textinput-Amc">
            <Autocomplete id="amc-search" options={amclistSearch} freeSolo getOptionLabel={o => (typeof o === 'string' ? o : o.name || "")} value={searchParams.amcName || ""} onInputChange={(_, val) => handleSearchChange("amcName", val)} onChange={(_, val) => handleSearchChange("amcName", typeof val === 'string' ? val : val?.name || "")} renderInput={p => <TextField {...p} label="AMC Name" variant="standard" style={{ width: "100%" }} />} />
          </div>
        </div>
        <div className="buttons-Amc" style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
          <Button onClick={handleSearch} sx={buttonStyle} variant="contained">Search</Button>
          <Button onClick={handleShowAll} sx={buttonStyle} variant="contained">Cancel</Button>
        </div>
        <div className="table-Amc">
          <div className="excelexport-Amc">
            <span className="buttons-Amc-span">
              <ExportToExcel name="Export to Excel" onClick={handleExport} />
            </span>
          </div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#fff" }} align="center">S.No.</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="left">AMC Name</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">Brand</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">Category</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">Sub Category</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">Model</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">AMC Cost (INR)</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">Duration (in Months)</TableCell>
                  <TableCell sx={{ color: "#fff" }} align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {amcs && amcs.length > 0 ? amcs.map((elem, ind) => (
                  <TableRow key={elem._id}>
                    <TableCell align="center">{ind + 1 + (page - 1) * pageSize}</TableCell>
                    <TableCell align="left">{elem.name}</TableCell>
                    <TableCell align="center">{elem.brandName || "--"}</TableCell>
                    <TableCell align="center">{elem.categoryName || "--"}</TableCell>
                    <TableCell align="center">{elem.subCategoryName || "--"}</TableCell>
                    <TableCell align="center">{elem.modelName || "--"}</TableCell>
                    <TableCell align="center">{elem.costOfService || "--"}</TableCell>
                    <TableCell align="center">{elem.duration || "--"}</TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => handleStatusChange(elem._id)} sx={iconButtonStyle}>
                        <img src={elem.active === false ? inactiveIcon : activeIcon} alt="status" height="20px" width="20px" />
                      </IconButton>
                      <IconButton onClick={() => { handleEdit(ind); scrollToEdit(); }} sx={iconButtonStyle}>
                        <img src={editIcon} alt="Edit" height="20px" width="20px" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )) : (
                  <TableRow><TableCell colSpan={9} align="center">No Data Available</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="pagination-container">
          <Paginate page={page} totalRecords={totalRecords} onPageChange={handlePageChange} dataSize={dataSize} />
        </div>
      </div>
    </>
  );
};

export default Amc;
